import React from 'react';
import ReactDOM from 'react-dom';
import SharedDownload from './templates/organisms/shared-download';
import {loadWidget} from '@sitevision/react';

loadWidget('[data-shared-document-widget-wrapper]', wrapper => {
    const action = wrapper.dataset.action;

    ReactDOM.render(<SharedDownload action={action}/>, wrapper);
})
